import apiDirectory from '@/api/directory'
import {filter, find, pipe, prop, propEq, whereEq} from 'ramda'

const state = {
  directory: [],
  directoryList: [],
  isLoading: false,
  isLoadingList: false,
  validationErrors: null,
  validationErrorsList: null,
  isSubmitting: false,

  directoryListAll: [],
  isLoadingListAll: false,
  validationErrorsListAll: null,
}

export const getterTypes = {
  getDirectoryNameByType: '[directory] getDirectoryNameByType',
  getDirectoryListByType: '[directory] getDirectoryListByType',
  vikoviHrupy: '[directory] vikoviHrupy',
  rivniGrup: '[directory] rivniGrup',
  sporRozryady: '[directory] sporRozryady',
  typZamahan: '[directory] typZamahan',
  pidtypZmahan: '[directory] pidtypZmahan',
  vydZmahan: '[directory] vydZmahan',
  zakhodyNapryamok: '[directory] zakhodyNapryamok',
  kpkv: '[directory] kpkv',
  rayon: '[directory] rayon',
  typysportobyektiv: '[directory] typysportobyektiv',
  rikNavchannya: '[directory] rikNavchannya',
  zbirnaUkrayiny: '[directory] zbirnaUkrayiny',
  statusSportsmena: '[directory] statusSportsmena',
  vydySportshkil: '[directory] vydySportshkil',
  formaVlasnostiSportshkil: '[directory] formaVlasnostiSportshkil',
  orhanizatoryZakhodu: '[directory] orhanizatoryZakhodu',
  uchasnykyZakhodu: '[directory] uchasnykyZakhodu',
  mistseProvedennya: '[directory] mistseProvedennya',
  rozporyadnykKoshtiv: '[directory] rozporyadnykKoshtiv',
  zbirnaKyyiv: '[directory] zbirnaKyyiv',
  natsionalniSportyvniFederatsiyi:
    '[directory] natsionalniSportyvniFederatsiyi',
  zakhodyPidnapryamok: '[directory] zakhodyPidnapryamok',
  katehoriyiTreneriv: '[directory] katehoriyiTreneriv',
  appealSubject: '[directory] appealSubject',
  rejectionApplication: '[directory] rejectionApplication',
  removalRequestRejectionReason: '[directory] removal-request-rejection-reason',
  militaryStatus: '[directory] militaryStatus',
  nosology: '[directory] nosology',
  coachLoad: '[directory] coachLoad',
  athleteDocumentsTypes: '[directory] athlete-documents-types',
}

const getters = {
  [getterTypes.getDirectoryNameByType]: (state) => (type) =>
    pipe(find(propEq('type', type)), prop('name'))(state.directory),

  [getterTypes.getDirectoryListByType]: (state) => (type) =>
    filter(whereEq({type}), state.directoryListAll),

  [getterTypes.vikoviHrupy]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('vikovi-hrupy'),

  [getterTypes.rivniGrup]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('rivni-grup'),

  [getterTypes.sporRozryady]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('spor-rozryady'),

  [getterTypes.typZamahan]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('typ-zamahan'),

  [getterTypes.pidtypZmahan]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('pidtyp-zmahan'),

  [getterTypes.vydZmahan]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('vyd-zmahan'),

  [getterTypes.zakhodyNapryamok]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('zakhody-napryamok'),

  [getterTypes.kpkv]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('kpkv'),

  [getterTypes.rayon]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('rayon'),

  [getterTypes.typysportobyektiv]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('typysportobyektiv'),

  [getterTypes.rikNavchannya]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('rik-navchannya'),

  [getterTypes.zbirnaUkrayiny]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('zbirna-ukrayiny'),

  [getterTypes.statusSportsmena]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('status-sportsmena'),

  [getterTypes.vydySportshkil]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('vydy-sportshkil'),

  [getterTypes.formaVlasnostiSportshkil]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('forma-vlasnosti-sportshkil'),

  [getterTypes.orhanizatoryZakhodu]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('orhanizatory-zakhodu'),

  [getterTypes.uchasnykyZakhodu]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('uchasnyky-zakhodu'),

  [getterTypes.mistseProvedennya]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('mistse-provedennya'),

  [getterTypes.rozporyadnykKoshtiv]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('rozporyadnyk-koshtiv'),

  [getterTypes.zbirnaKyyiv]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('zbirna-kyyiv'),

  [getterTypes.natsionalniSportyvniFederatsiyi]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType](
      'natsionalni-sportyvni-federatsiyi'
    ),

  [getterTypes.zakhodyPidnapryamok]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('zakhody-pidnapryamok'),

  [getterTypes.katehoriyiTreneriv]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('katehoriyi-treneriv'),

  [getterTypes.appealSubject]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('appeal-subject'),

  [getterTypes.rejectionApplication]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('rejection-application'),

  [getterTypes.removalRequestRejectionReason]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType](
      'removal-request-rejection-reason'
    ),

  [getterTypes.militaryStatus]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('military-status'),

  [getterTypes.nosology]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('nosology'),

  [getterTypes.coachLoad]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('coach-load'),

  [getterTypes.athleteDocumentsTypes]: (state, getters) =>
    getters[getterTypes.getDirectoryListByType]('athlete-documents-types'),
}

export const mutationTypes = {
  getDirectoryStart: '[directory] getDirectoryStart',
  getDirectorySuccess: '[directory] getDirectorySuccess',
  getDirectoryFailure: '[directory] getDirectoryFailure',

  addDirectoryListStart: '[directory] addDirectoryListStart',
  addDirectoryListSuccess: '[directory] addDirectoryListSuccess',
  addDirectoryListFailure: '[directory] addDirectoryListFailure',

  getDirectoryListStart: '[directory] getDirectoryListStart',
  getDirectoryListSuccess: '[directory] getDirectoryListSuccess',
  getDirectoryListFailure: '[directory] getDirectoryListFailure',

  deleteDirectoryListStart: '[directory] deleteDirectoryListStart',
  deleteDirectoryListSuccess: '[directory] deleteDirectoryListSuccess',
  deleteDirectoryListFailure: '[directory] deleteDirectoryListFailure',

  getDirectoryListAllStart: '[directory] getDirectoryListAllStart',
  getDirectoryListAllSuccess: '[directory] getDirectoryListAllSuccess',
  getDirectoryListAllFailure: '[directory] getDirectoryListAllFailure',

  clearDirectoryList: '[directory] clearDirectoryList',
}

export const actionType = {
  getDirectory: '[directory] getDirectory',
  addDirectoryList: '[directory] addDirectoryList',
  getDirectoryList: '[directory] getDirectoryList',
  deleteDirectoryList: '[directory] deleteDirectoryList',
  getDirectoryAllList: '[directory] getDirectoryAllList',
}

const mutations = {
  [mutationTypes.getDirectoryStart](state) {
    state.isLoading = true
    state.validationErrors = null
  },

  [mutationTypes.getDirectorySuccess](state, payload) {
    state.isLoading = false
    state.directory = payload
  },

  [mutationTypes.getDirectoryFailure](state, payload) {
    state.isLoading = false
    state.validationErrors = payload
  },

  [mutationTypes.addDirectoryListStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.addDirectoryListSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.addDirectoryListFailure](state) {
    state.isSubmitting = false
  },

  [mutationTypes.getDirectoryListStart](state) {
    state.isLoadingList = true
    state.validationErrorsList = null
  },

  [mutationTypes.getDirectoryListSuccess](state, payload) {
    state.isLoadingList = false
    state.directoryList = payload
  },

  [mutationTypes.getDirectoryListFailure](state, payload) {
    state.isLoadingList = false
    state.validationErrorsList = payload
  },

  [mutationTypes.deleteDirectoryListStart]() {},

  [mutationTypes.deleteDirectoryListSuccess]() {},

  [mutationTypes.deleteDirectoryListFailure]() {},
  [mutationTypes.clearDirectoryList](state) {
    state.directoryList = []
  },

  [mutationTypes.getDirectoryListAllStart](state) {
    state.isLoadingListAll = true
    state.validationErrorsListAll = null
  },

  [mutationTypes.getDirectoryListAllSuccess](state, payload) {
    state.isLoadingListAll = false
    state.directoryListAll = payload
  },

  [mutationTypes.getDirectoryListAllFailure](state, payload) {
    state.isLoadingListAll = false
    state.validationErrorsListAll = payload
  },
}

const actions = {
  [actionType.getDirectory](context) {
    context.commit(mutationTypes.getDirectoryStart)
    return new Promise((resolve) => {
      apiDirectory
        .getDirectory()
        .then((response) => {
          context.commit(mutationTypes.getDirectorySuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getDirectoryFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.addDirectoryList](context, directory) {
    context.commit(mutationTypes.addDirectoryListStart)
    return new Promise((resolve) => {
      apiDirectory
        .addDirectory(directory)
        .then((response) => {
          context.commit(mutationTypes.addDirectoryListSuccess, response.data)
          context.dispatch(actionType.getDirectory)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.addDirectoryListFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.getDirectoryList](context, {type}) {
    context.commit(mutationTypes.getDirectoryListStart)
    return new Promise((resolve) => {
      apiDirectory
        .getDirectoryList(type)
        .then((response) => {
          context.commit(mutationTypes.getDirectoryListSuccess, response.data)
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getDirectoryListFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.deleteDirectoryList](context, {id}) {
    context.commit(mutationTypes.deleteDirectoryListStart)
    return new Promise((resolve) => {
      apiDirectory
        .deleteDirectoryList(id)
        .then((response) => {
          context.commit(
            mutationTypes.deleteDirectoryListSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.deleteDirectoryListFailure,
            result.response.data.errors
          )
        })
    })
  },

  [actionType.getDirectoryAllList](context) {
    context.commit(mutationTypes.getDirectoryListAllStart)
    return new Promise((resolve) => {
      apiDirectory
        .getDirectoryListAll()
        .then((response) => {
          context.commit(
            mutationTypes.getDirectoryListAllSuccess,
            response.data
          )
          resolve(response.data)
        })
        .catch((result) => {
          context.commit(
            mutationTypes.getDirectoryListAllFailure,
            result.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
